// The one score -> band rule, imported by the /app SPA and the server
// (downlink projection). The cut-offs are score_bands in
// contracts/design-tokens.json (the vendored PR-Sensei-Shared token file),
// which /next reads through its generated module;
// test/score-band.test.js pins the two together so they cannot drift.
//
// The tier names are internal. Each surface keeps the words it already
// ships: /app says good / watch / attention, the downlink says
// excellent / good / fair / poor because shipped firmware parses those
// strings. What the rule fixes is WHERE each surface changes colour.

export const SCORE_TIERS = [
  { min: 90, tier: 'excellent' },
  { min: 75, tier: 'steady' },
  { min: 55, tier: 'watch' },
  { min: 0, tier: 'urgent' },
];

export function scoreTier(score) {
  if (score == null) return null;
  const n = Number(score);
  if (!Number.isFinite(n)) return null;
  return (SCORE_TIERS.find((t) => n >= t.min) || SCORE_TIERS[SCORE_TIERS.length - 1]).tier;
}
